import { AccordionAnimation } from "@components/Accordion/AccordionAnimation";
import Container from "@components/Atomic/Container/Container";
import { Icon } from "@components/Icon";
import { StyledContainer } from "@components/Styled/Container";
import { styledWithInvalidProps } from "@components/Styled/StyledWithInvalidProps";
import React from "react";
import tw from "twin.macro";
import { withAccordion } from "./withAccordion";

type TitleProps = {
  active: number | null;
};

const InnerContainer = tw(StyledContainer)`
  flex
`;
const Sections = tw.div`
  max-w-md mx-auto
`;
const Wrapper = tw.div`border-b border-primary`;

const Title = styledWithInvalidProps("div")(({ active }: TitleProps) => [
  tw`flex flex-row items-center justify-between cursor-pointer text-body leading-h2 py-mini`,
  active ? tw`font-medium` : tw`font-normal`,
]);

const Accordion = withAccordion(({ contents, active, handleClick, styles }) => {
  return (
    <Container styles={styles} data-component-type="section-accordion">
      <InnerContainer>
        <Sections>
          {contents?.map((content, index) => (
            <Wrapper key={content.title}>
              <Title active={index === active} onClick={handleClick(index)}>
                <p>{content.title}</p>
                {index !== active ? (
                  <Icon
                    name="plus"
                    size="xxs"
                    data-testid={`section-accordion-icon-plus-${index}`}
                  />
                ) : (
                  <Icon
                    name="minus"
                    size="xxs"
                    data-testid={`section-accordion-icon-minus-${index}`}
                  />
                )}
              </Title>
              <AccordionAnimation active={index === active}>
                <div className={"rte"}>{content.content}</div>
              </AccordionAnimation>
            </Wrapper>
          ))}
        </Sections>
      </InnerContainer>
    </Container>
  );
});

export default Accordion;
